import { Link } from "react-router";
import { ERKLAERT } from "./Privat";

export function Erklaert() {
  return (
    <section data-page="erklaert" className="wrap chapter">
      <div className="proof-head">
        <span className="eyebrow">Vero erklärt</span>
        <h1>Ehrliche Antworten, kein Geschwafel.</h1>
        <p className="lead">Vier Fragen, die Hausbesitzer oft haben. Kurz beantwortet, ohne Verkaufsdruck.</p>
      </div>
      {ERKLAERT.map((f) => (
        <article className="erklaert" key={f.q}>
          <h2>{f.q}</h2>
          {f.a.map((t, i) => (
            <p key={i}>{t}</p>
          ))}
        </article>
      ))}
      <p className="note-small">Allgemeine Information, keine Rechtsberatung. Für Ihren Einzelfall fragen Sie eine Fachkraft.</p>
      <p>
        <Link className="btn btn-primary" to="/privat/registrieren">
          Hausakte kostenlos anlegen
        </Link>
      </p>
    </section>
  );
}
